import { observer } from "mobx-react-lite";
import { FC } from "react";
import { MDSTextColor, MDSTextWeight, MDSTextVariant, MDSText, MDSIcon, MDSIconKind } from "@/mds";
import styled from "@emotion/styled";
import { Button } from "react-aria-components";

export interface AuthCardEmailPasswordButtonBaseProps {
  onClick: () => void;
  label: string;
}

export const AuthCardEmailPasswordButtonBase: FC<AuthCardEmailPasswordButtonBaseProps> = observer(
  ({ onClick, label }) => {
    return (
      <StyledAuthButton onClick={onClick}>
        <MDSIcon kind={MDSIconKind.Envelope} />
        <MDSText
          variant={MDSTextVariant.TextM}
          weight={MDSTextWeight.Regular}
          color={MDSTextColor.Contrast}
        >
          {label}
        </MDSText>
      </StyledAuthButton>
    );
  }
);

const StyledAuthButton = styled(Button)`
  font-size: ${({ theme }) => theme.fontSizes["text-m"]};
  border-radius: ${({ theme }) => theme.borderRadius.max};
  display: flex;
  width: 320px;
  padding-block: ${({ theme }) => theme.spacing[4]};
  padding-inline: ${({ theme }) => theme.spacing[6]};
  gap: ${({ theme }) => theme.spacing[2]};
  justify-content: center;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colors.border.button.marketing.default};

  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.border.button.marketing.hover};
  }
`;
